<template>
  <div class="flex flex-col items-center justify-center h-full">
    <span v-if="loading">
      <PulseLoader />
      Loading...
    </span>
    <span v-if="success">
      Stripe account connected.
    </span>
    <span v-if="error">
      Error connecting stripe account.
      {{ error }}
    </span>
    <el-button v-if="success || error" class="mt-4" type="primary" @click="closeWindow">Close this window</el-button>
  </div>
</template>
<script setup>
import { ref, nextTick } from "vue";
import api from "@/composables/api";
import { useRoute } from 'vue-router'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { useUser } from '@/stores';
const userStore = useUser()

const route = useRoute()
const hash = route.query.state

let code = null
const success = ref(false)
const loading = ref(true)
const error = ref('')

const connectStripe = () => {
  api(`v1/stripe/connect`, {
    method: "POST",
    body: {
      authCode: code,
      uriHash: hash
    }
  }).then((res) => {
    //TODO: need to have store watch local storage for this to update all windows
    userStore.setSettings(res.data.userSettings)
    loading.value = false
    success.value = true
  }).catch((err) => {
    //TODO: handle any type of error so the screen isn't blank
    success.value = false
    loading.value = false
    //this is too specific, fails on network error
    error.value = err.data.error
    loading.value = false
  });
}

const closeWindow = () => {
  window.close();
};

const interval = setInterval(() => {
  nextTick(() => {
    //console.log("StripeSuccessView nextTick");
  })
  const urlParams = new URLSearchParams(window.location.search);
  code = urlParams.get('code');
  if (code) {
    connectStripe()
    clearInterval(interval)
  }
}, 2000)

</script>